import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getMoreDropdownEntryProps } from './moreNavigationAnalytics';

const DropdownAnchor = styled.a`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${({ theme }) => theme.c.text.interactive};
  padding-left: ${(p) => p.theme.unit(2)};
  text-decoration: none;
  display: block;
  padding-top: ${({ theme }) => theme.unit(1)};
  padding-bottom: ${({ theme }) => theme.unit(1)};
  cursor: pointer;
  :hover {
    color: ${({ theme }) => theme.c.text['interactive-hover']};
    text-decoration: underline;
  }
`;

const GenericDropdownDiv = styled.div`
  width: ${p => p.theme.unit(37)};
  box-shadow: 0 2px 8px 0 ${({ theme }) => theme.c.border['box-shadow']};
  border: solid 1px ${({ theme }) => theme.c.border.primary};
  text-align: left;
  background-color: ${p => p.theme.c.bg.primary};
  > :first-child {
    margin-top: ${p => p.theme.unit(1)};
  }
  > :last-child {
    margin-bottom: ${p => p.theme.unit(1)};
  }
`;

const HoverRule = styled.div`
  :hover {
    cursor: pointer;
    background-color: ${p => p.theme.c.bg.secondary};
  }
`;

export const Entry = ({ text, analyticsSlug, url, openInNewTab, locale, click }) => {
  const trackingProps = getMoreDropdownEntryProps({
    analyticsSlug,
    url,
    locale,
  });

  return (
    <DropdownAnchor
      {...trackingProps}
      target={openInNewTab ? '_blank' : '_self'}
      onClick={click}>
      {text}
    </DropdownAnchor>
  );
};

const GenericDropdown = ({ locale, dropdownEntries }) => {
  return (
    <GenericDropdownDiv>
      {
        dropdownEntries &&
        dropdownEntries.length &&
        dropdownEntries.map(e => <HoverRule><Entry {...e} locale={locale} /></HoverRule>)
      }
    </GenericDropdownDiv>
  );
};

GenericDropdown.defaultProps = {
  dropdownEntries: [],
};

GenericDropdown.propTypes = {
  dropdownEntries: PropTypes.arrayOf(PropTypes.object),
};

export default GenericDropdown;
